import { siteInfo, heroStats } from '@/mocks/home';

export default function Hero() {
  const handleScroll = (href: string) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(var(--primary-500)) 0%, transparent 60%), radial-gradient(circle at 80% 20%, oklch(var(--accent-500)) 0%, transparent 50%)',
      }}></div>

      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto relative z-10 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 px-4 py-1.5 rounded-full text-xs font-medium mb-6 whitespace-nowrap">
              <i className="ri-sparkling-line text-sm"></i>
              <span>多频道影视内容聚合平台</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              {siteInfo.name}<br className="hidden sm:block" />
              <span className="text-primary-500">汇聚多元影视</span>，发现专属片单
            </h1>

            <p className="text-lg md:text-xl font-display text-accent-600 mb-4">
              {siteInfo.slogan}
            </p>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[600px] lg:max-w-none mb-6">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 border-2 border-background-300 text-foreground-700 px-8 py-3.5 rounded-full text-sm font-semibold hover:border-primary-400 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
              >
                <i className="ri-grid-line text-lg"></i>
                浏览全部频道
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20home%20cinema%20setup%20with%20a%20large%20screen%20displaying%20colorful%20movie%20posters%20grid%2C%20warm%20ambient%20lighting%2C%20cozy%20sofa%20with%20cushions%2C%20popcorn%20bowl%2C%20surround%20sound%20speakers%2C%20cinematic%20atmosphere%2C%20rich%20warm%20amber%20and%20coral%20tones%2C%20inviting%20entertainment%20space&width=1000&height=750&seq=mahua-hero-main&orientation=landscape"
                alt="麻花影视 - 多频道影视内容聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/10 via-transparent to-primary-500/5"></div>

              <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                {['番茄影视', '四虎影视', '影视飓风', '桃花影视'].map((name) => (
                  <span key={name} className="bg-background-50/90 backdrop-blur-sm text-foreground-800 text-xs px-3 py-1.5 rounded-full font-medium whitespace-nowrap">
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}